module.exports = __webpack_public_path__ + "static/img/yun.d13e4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/yun.png
// module id = kWZG
// module chunks = 17